import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "py-10" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h1 class=\"anchor fw-bolder mb-5\" id=\"nesting\"><a href=\"#nesting\"></a> Nesting </h1><div class=\"py-5\"> Border styles, active styles, and table variants are not inherited by nested tables. </div><div class=\"my-5\"><table class=\"table table-striped table-rounded border border-gray-300 table-row-bordered table-row-gray-300 gy-7 gs-7\"><thead><tr class=\"fw-bold fs-4 text-gray-800\"><th scope=\"col\">#</th><th scope=\"col\">First</th><th scope=\"col\">Last</th><th scope=\"col\">Handle</th></tr></thead><tbody><tr><th scope=\"row\">1</th><td>Mark</td><td>Otto</td><td>@mdo</td></tr><tr><td colspan=\"4\"><table class=\"table table-row-dashed table-row-gray-500 gy-5 gs-5 mb-0\"><thead><tr class=\"fw-bold fs-5 text-gray-800\"><th scope=\"col\">Header</th><th scope=\"col\">Header</th><th scope=\"col\">Header</th></tr></thead><tbody><tr><th scope=\"row\">A</th><td>First</td><td>Last</td></tr><tr><th scope=\"row\">B</th><td>First</td><td>Last</td></tr><tr><th scope=\"row\">C</th><td>First</td><td>Last</td></tr></tbody></table></td></tr><tr><th scope=\"row\">3</th><td>Larry</td><td>the Bird</td><td>@twitter</td></tr></tbody></table></div>", 3)
const _hoisted_5 = { class: "py-5" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(`
        <table
          class="table table-striped table-rounded border border-gray-300 table-row-bordered table-row-gray-300 gy-7 gs-7"
        >
          <thead>
            <tr class="fw-bold fs-4 text-gray-800">
              <th scope="col">#</th>
              <th scope="col">First</th>
              <th scope="col">Last</th>
              <th scope="col">Handle</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row">1</th>
              <td>Mark</td>
              <td>Otto</td>
              <td>@mdo</td>
            </tr>
            <tr>
              <td colspan="4">
                <table
                  class="table table-row-dashed table-row-gray-500 gy-5 gs-5 mb-0"
                >
                  <thead>
                    <tr class="fw-bold fs-5 text-gray-800">
                      <th scope="col">Header</th>
                      <th scope="col">Header</th>
                      <th scope="col">Header</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row">A</th>
                      <td>First</td>
                      <td>Last</td>
                    </tr>
                    <tr>
                      <th scope="row">B</th>
                      <td>First</td>
                      <td>Last</td>
                    </tr>
                    <tr>
                      <th scope="row">C</th>
                      <td>First</td>
                      <td>Last</td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <th scope="row">3</th>
              <td>Larry</td>
              <td>the Bird</td>
              <td>@twitter</td>
            </tr>
          </tbody>
        </table>
        `))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_5, [
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      })
    ])
  ]))
}